import { apiRequest } from './client'
import type { LoginResponse } from '@/types/api'

export function login(email: string, password: string) {
  return apiRequest<LoginResponse>('/api/root/auth/login', {
    method: 'POST',
    body: { email, password },
    retry: false,
  })
}

export function logout() {
  return apiRequest<{ loggedOut: boolean }>('/api/root/auth/logout', {
    method: 'POST',
    retry: false,
  })
}

export function refresh() {
  return apiRequest<{ accessToken: string; expiresAt: string }>('/api/root/auth/refresh', {
    method: 'POST',
    retry: false,
  })
}
